import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './views/list/list.component';
import { DetailComponent } from './views/list/detail/detail.component';
import { FormsModule, UntypedFormBuilder } from '@angular/forms';
import { NotificationsModule } from 'projects/core/src/common/notifications/notifications.module';
import { CustomfieldsModule } from 'projects/core/src/common/customfields/customfields.module';
import { WindowModule } from 'projects/core/src/common/window/window.module';
import { WindowlistModule } from 'projects/core/src/common/windowlist/windowlist.module';
import { PaginationModule } from 'projects/core/src/common/pagination/pagination.module';
import { CitiesModule } from 'projects/c1-backend/src/app/modules/cities/cities.module';
import { ToolbarmodelModule } from 'projects/core/src/common/toolbarmodel/toolbarmodel.module';
import { TypeModule } from 'projects/c1-backend/src/app/modules/type/type.module';
import { FilesModule } from 'projects/c1-backend/src/app/modules/files/files.module';
import { DocumentsModule } from 'projects/c1-backend/src/app/views/documents/documents.module';
import { TodoRoutingModule } from './todo-routing.module';
import { Globals } from 'projects/core/src/globals';
import { TodoService } from './services/todo.service';
import { ToDo } from './todo';
import { SelectfieldcustomModule } from 'projects/core/src/common/selectfieldcustom/selectfieldcustom.module';
import { TodolistComponent } from './views/todolist/todolist.component';



@NgModule({
  declarations: [ListComponent,DetailComponent,TodolistComponent],
  exports:[ListComponent,DetailComponent,TodolistComponent],
  imports: [
    CommonModule,
    TodoRoutingModule,
    FormsModule,
    NotificationsModule,
    
    WindowModule,
    WindowlistModule,
    PaginationModule,
    CitiesModule,
    ToolbarmodelModule,
    TypeModule,
    FilesModule,
    SelectfieldcustomModule
  ]
})
export class TodoModule { 

  static addTodo(id_address:any){
    let s= new TodoService()
    let m=new ListComponent({} as UntypedFormBuilder,s)
    m.detailViewModal=DetailComponent;
    m.openDetail(new ToDo(),[{"name":"id_address","value":id_address}])
    
  }

  static getTodo(id_address:any){

    if(id_address>0){
      let service= new TodoService()
      service.getTodoByAddress(id_address).subscribe((result:any)=>{
          if(result){
            Globals.modal.showModal(TodolistComponent,[{"name":"list","value":result}],()=>{

            },"md")
          }
      })
    }

  }



}
